import { render, staticRenderFns } from "./transaction-summary-actions.vue?vue&type=template&id=065065ec&"
import script from "./transaction-summary-actions.vue?vue&type=script&lang=js&"
export * from "./transaction-summary-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports